import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./StandardLayout.scss";
import { LeftOutlined } from "@ant-design/icons";
import { Layout } from "antd";
import { useEffect, useState } from "react";
import { SideMenu } from "../../components/SideMenu/SideMenu";
import { TopBar } from "../../components/Topbar/Topbar";
import { StandardLayoutRoute } from "./StandardLayoutRoute";
import { Button } from "../../components/Button/Button";
const { Sider, Content } = Layout;
/**
 * The standard layout for the application.
 * Contains a topbar, sidebar, and content area.
 * Routing should be handled by the project, set useBuiltInRouter to false.
 *
 * This component will likely be deprecated in the future, as it's not flexible enough.
 */
export function StandardLayoutWrapper(props) {
    if (props.useBuiltInRouter === false) {
        return _jsx(StandardLayout, Object.assign({}, props));
    }
    return _jsx(StandardLayoutRoute, Object.assign({}, props));
}
function StandardLayout({ topBarProps, children, sideMenuProps, navigation, path }) {
    var _a, _b;
    const [currentNavigation, setCurrentNavigation] = useState();
    const [topBarSelection, setTopBarSelection] = useState();
    const [collapsed, setCollapsed] = useState((_a = sideMenuProps === null || sideMenuProps === void 0 ? void 0 : sideMenuProps.isCollapsed) !== null && _a !== void 0 ? _a : false);
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };
    useEffect(() => {
        if (!path) {
            return setCurrentNavigation(undefined);
        }
        const pathElements = path.split("/").filter(Boolean);
        const navigationItem = navigation.find((item) => item.path === `/${pathElements[0]}`);
        if ((navigationItem === null || navigationItem === void 0 ? void 0 : navigationItem.dropdown) && pathElements.length > 1) {
            const dropdownItem = navigationItem.dropdown.find((item) => item.path === `/${pathElements[0]}/${pathElements[1]}`);
            if (dropdownItem) {
                return setCurrentNavigation(dropdownItem);
            }
        }
        setCurrentNavigation(navigationItem);
    }, [path, navigation]);
    useEffect(() => {
        var _a;
        setTopBarSelection((_a = currentNavigation === null || currentNavigation === void 0 ? void 0 : currentNavigation.path) !== null && _a !== void 0 ? _a : "");
    }, [currentNavigation === null || currentNavigation === void 0 ? void 0 : currentNavigation.path]);
    return (_jsxs(Layout, { "data-testid": "standard-layout-wrapper", style: { margin: 0, padding: 0, maxWidth: "none", height: "100vh" }, children: [_jsx(TopBar, Object.assign({}, topBarProps, { navigation: navigation, onClick: topBarProps.onClick, useBuiltInRouter: false, selected: topBarSelection })), _jsxs(Layout, { className: "standard-layout-page-wrapper", children: [(currentNavigation === null || currentNavigation === void 0 ? void 0 : currentNavigation.subItems) ? (_jsxs(Sider, { className: "te-sidemenu", trigger: null, collapsible: true, theme: "light", collapsed: collapsed, children: [_jsx(SideMenu, { header: currentNavigation.subItemsHeader, navigation: (_b = currentNavigation === null || currentNavigation === void 0 ? void 0 : currentNavigation.subItems) !== null && _b !== void 0 ? _b : [], isCollapsed: collapsed, path: path, onClick: sideMenuProps.onClick }), _jsx("div", { className: "collapse-button-wrapper", children: _jsx(Button, { className: `collapse-button ${collapsed ? "collapsed" : "expanded"}`, shape: "circle", onClick: toggleCollapsed, children: _jsx(LeftOutlined, {}) }) })] })) : null, _jsx(Content, { "data-testid": "standard-layout-test-content-wrapper", className: "standard-layout-content-wrapper", children: children })] })] }));
}
